var Z = Object.defineProperty;
var U = Object.getOwnPropertySymbols;
var ee = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable;
var q = (f, n, o) => n in f ? Z(f, n, { enumerable: !0, configurable: !0, writable: !0, value: o }) : f[n] = o, E = (f, n) => {
  for (var o in n || (n = {}))
    ee.call(n, o) && q(f, o, n[o]);
  if (U)
    for (var o of U(n))
      re.call(n, o) && q(f, o, n[o]);
  return f;
};
var D = (f, n, o) => new Promise((_, g) => {
  var m = (d) => {
    try {
      v(o.next(d));
    } catch (p) {
      g(p);
    }
  }, c = (d) => {
    try {
      v(o.throw(d));
    } catch (p) {
      g(p);
    }
  }, v = (d) => d.done ? _(d.value) : Promise.resolve(d.value).then(m, c);
  v((o = o.apply(f, n)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getGetDefaultListByServiceId as le } from "../../request/designordercenter/productionOrder/receiver/getDefaultListByServiceId/get.js";
import { getGetAddressCarrierById as ae } from "../../request/designordercenter/productionOrder/receiver/getAddressCarrierById/get.js";
import te from "../../com-components/op-region-select/RegionSelect.vue.js";
import "../../com-components/op-region-select/RegionSelect.vue2.js";
import F from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tag/src/Tag.js";
import { defineComponent as ie, useTemplateRef as oe, onMounted as se, openBlock as R, createElementBlock as P, createElementVNode as b, createVNode as s, withCtx as u, Fragment as z, renderList as ue, createTextVNode as w, createBlock as k, createCommentVNode as L } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ne } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as y, unref as i } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import de from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import M from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ve from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/Tabs.js";
import G from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/TabPane.js";
import fe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import j from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ce from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import { normalizeStyle as me, toDisplayString as C } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const ge = { style: { height: "360px" } }, pe = {
  key: 0,
  style: { display: "flex", "flex-wrap": "wrap", gap: "15px", "justify-content": "flex-start", height: "360px", overflow: "auto" }
}, ye = { style: { "font-size": "16px", "font-weight": "bold" } }, he = {
  key: 1,
  style: { height: "360px" },
  class: "tw:text-center"
}, Ne = { style: { width: "100%", display: "flex", "justify-content": "center", "margin-top": "20px" } }, Le = /* @__PURE__ */ ie({
  __name: "receiveAddress.ce",
  emits: ["submit"],
  setup(f, { expose: n, emit: o }) {
    const _ = oe("receiveAddressContainer"), g = ne(), m = y(!1), c = y([]), v = y({
      serviceId: "",
      selectedItemId: "",
      receiver: "",
      receiverTel: "",
      receiverRegion: "",
      receiverRegionPids: "",
      receiveAddress: "",
      address: "",
      regionName: ""
    }), d = y(!1), p = y(), W = {
      receiver: {
        required: !0,
        trigger: ["input"],
        message: "请输入收货人"
      },
      receiverTel: {
        required: !0,
        trigger: ["blur", "input"],
        message: "请输入收货电话",
        // 添加pattern验证，确保是11位数字
        pattern: /^1\d{10}$/,
        // 添加自定义验证器以提供更详细的错误信息
        validator: (l, a) => {
          if (!a)
            return new Error("请输入收货电话");
          const r = /^1[3-9]\d{9}$/, N = /^0\d{2,3}[-\s]?\d{7,8}([-\s]?\d{1,4})?$/;
          return !r.test(a) && !N.test(a) ? new Error("请输入正确的手机号码或固定电话号码格式") : !0;
        }
      },
      receiverRegion: {
        required: !0,
        trigger: ["blur", "input"],
        message: "请选择收货地址"
      },
      receiverRegionPids: {
        required: !0,
        trigger: ["blur", "input"],
        message: "请选择收货地址"
      },
      address: {
        required: !0,
        trigger: ["blur", "input"],
        message: "请输入收货地址"
      }
    }, e = y({
      receiver: "",
      receiverTel: "",
      receiverRegion: "",
      receiverRegionPids: "",
      receiveAddress: "",
      id: "",
      address: "",
      regionName: "",
      isDefault: 0,
      isShopDefault: 0
    }), t = y(null), H = (l) => {
      t.value = l, console.log("选中的项目:", l);
    }, h = y("一件代发/快递等"), J = (l) => {
      h.value = l, l === "承运商发货" ? A(
        v.value.serviceId || "",
        v.value.selectedItemId || ""
      ) : (v.value.selectedItemId && x(), t.value = null), console.log("选中的项目tab:", l);
    };
    se(() => D(this, null, function* () {
    }));
    const A = (l, a) => D(this, null, function* () {
      try {
        if (!l)
          return;
        d.value = !0;
        const r = yield le({ serviceId: l });
        r && r.data && r.status ? (d.value = !1, c.value = r.data || [], c.value = c.value.map((N) => E({}, N)), a && (t.value = c.value.find((N) => N.id === a) || null, h.value = "承运商发货")) : (console.warn("获取数据失败：response 或 data 为空"), g.error((r == null ? void 0 : r.message) || "获取数据失败"), c.value = []);
      } catch (r) {
        d.value = !1, console.error("请求失败:", r), c.value = [];
      }
    }), x = () => {
      e.value = {
        receiver: "",
        receiverTel: "",
        receiverRegion: "",
        receiverRegionPids: "",
        receiveAddress: "",
        id: "",
        address: "",
        regionName: "",
        isDefault: 0,
        isShopDefault: 0
      };
    }, K = (l) => {
      e.value.receiverRegionPids = l.pids, e.value.regionName = l.pidsName;
    };
    let T = null;
    function O(l) {
      x(), v.value = l, e.value.receiver = l.receiver || "", e.value.receiverTel = l.receiverTel || "", e.value.receiverRegion = l.receiverRegion || "", e.value.receiverRegionPids = l.receiverRegionPids || "", e.value.receiveAddress = l.receiveAddress || "", e.value.address = l.address || "", e.value.regionName = l.regionName || "", console.log("openParams.value----", v.value), v.value.selectedItemId && (h.value = "承运商发货", A(
        v.value.serviceId || "",
        v.value.selectedItemId || ""
      )), m.value = !0;
    }
    const Q = () => {
      m.value = !1, T = null, x();
    }, X = () => D(this, null, function* () {
      if (!(h.value === "一件代发/快递等" && !p.value)) {
        if (h.value === "一件代发/快递等") {
          let l = e.value.receiverRegionPids && e.value.receiverRegionPids.split(",") || [];
          if (!l.length || !l[3]) {
            g.warning("收货地址行政区划有误！");
            return;
          }
          p.value && p.value.validate((a) => {
            a ? g.warning("请完善表单信息") : (m.value = !1, e.value.receiveAddress = `${e.value.regionName}${e.value.address}`, V("submit", e.value));
          });
        }
        if (h.value === "承运商发货") {
          if (!t.value) {
            g.warning("请选择收货地址");
            return;
          }
          e.value.receiver = t.value.receiver, e.value.receiverTel = t.value.receiverTel, e.value.receiverRegion = t.value.region, e.value.receiverRegionPids = t.value.regionPids, e.value.receiveAddress = `${t.value.regionName}${t.value.address}`, e.value.id = t.value.id, e.value.address = t.value.address, e.value.regionName = t.value.regionName, e.value.isDefault = t.value.isDefault, e.value.isShopDefault = t.value.isShopDefault;
          try {
            d.value = !0;
            const l = yield ae({ id: t.value.id });
            l && l.status && !l.data && g.warning("该收货地址没有发起承运商流程，将无法传单，需要尽快发起流程");
          } catch (l) {
            console.error(l);
          } finally {
            d.value = !1;
          }
          m.value = !1, V("submit", e.value);
        }
        console.log("formData.value----", e.value);
      }
    }), V = o, Y = () => {
      m.value = !1, x(), T && (T([]), T = null);
    };
    return n({ open: O }), (l, a) => (R(), P(z, null, [
      b("div", {
        ref_key: "receiveAddressContainer",
        ref: _
      }, null, 512),
      s(i(ce), {
        bordered: "",
        show: m.value,
        "onUpdate:show": a[5] || (a[5] = (r) => m.value = r),
        "mask-closable": !1,
        "z-index": 3e3,
        to: _.value || "body"
      }, {
        default: u(() => [
          s(i(de), { show: d.value }, {
            default: u(() => [
              s(i(M), {
                style: { width: "1000px" },
                title: "选择收货地址",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: Q
              }, {
                default: u(() => [
                  s(i(ve), {
                    type: "line",
                    animated: "",
                    "default-value": h.value,
                    "onUpdate:value": J
                  }, {
                    default: u(() => [
                      s(i(G), {
                        name: "一件代发/快递等",
                        tab: "一件代发/快递等"
                      }, {
                        default: u(() => [
                          b("div", ge, [
                            s(i(fe), {
                              ref_key: "formRef",
                              ref: p,
                              model: e.value,
                              rules: W
                            }, {
                              default: u(() => [
                                s(i(I), {
                                  label: "收货人",
                                  path: "receiver"
                                }, {
                                  default: u(() => [
                                    s(i(S), {
                                      value: e.value.receiver,
                                      "onUpdate:value": a[0] || (a[0] = (r) => e.value.receiver = r),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                s(i(I), {
                                  label: "收货电话",
                                  path: "receiverTel"
                                }, {
                                  default: u(() => [
                                    s(i(S), {
                                      value: e.value.receiverTel,
                                      "onUpdate:value": a[1] || (a[1] = (r) => e.value.receiverTel = r),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                s(i(I), {
                                  label: "收货地址",
                                  path: "address"
                                }, {
                                  default: u(() => [
                                    s(te, {
                                      modelValue: e.value.receiverRegion,
                                      "onUpdate:modelValue": a[2] || (a[2] = (r) => e.value.receiverRegion = r),
                                      modelValue2: e.value.receiverRegionPids,
                                      "onUpdate:modelValue2": a[3] || (a[3] = (r) => e.value.receiverRegionPids = r),
                                      isShowCountry: !1,
                                      onChooseRegionData: K
                                    }, null, 8, ["modelValue", "modelValue2"]),
                                    s(i(S), {
                                      placeholder: "请输入收货地址",
                                      clearable: "",
                                      value: e.value.address,
                                      "onUpdate:value": a[4] || (a[4] = (r) => e.value.address = r)
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"])
                          ])
                        ]),
                        _: 1
                      }),
                      s(i(G), {
                        name: "承运商发货",
                        tab: "承运商发货"
                      }, {
                        default: u(() => [
                          c.value.length > 0 ? (R(), P("div", pe, [
                            (R(!0), P(z, null, ue(c.value, (r, N) => {
                              var $, B;
                              return R(), k(i(M), {
                                key: N,
                                hoverable: "",
                                class: "receive-address-n-card",
                                style: me({
                                  width: "calc(33% - 14px)",
                                  height: "110px",
                                  minWidth: "200px",
                                  backgroundColor: (($ = t.value) == null ? void 0 : $.id) === r.id ? "#1890ff" : "#f5f5f5",
                                  cursor: "pointer",
                                  color: ((B = t.value) == null ? void 0 : B.id) === r.id ? "#ffffff" : "#000000"
                                }),
                                onClick: (Re) => H(r)
                              }, {
                                default: u(() => [
                                  b("span", ye, C(r.receiver), 1),
                                  w(" " + C(r.receiverTel) + " ", 1),
                                  r.isDefault && !r.isShopDefault ? (R(), k(i(F), {
                                    key: 0,
                                    style: { float: "right" }
                                  }, {
                                    default: u(() => a[6] || (a[6] = [
                                      w(" 商场默认 ", -1)
                                    ])),
                                    _: 1,
                                    __: [6]
                                  })) : L("", !0),
                                  r.isShopDefault ? (R(), k(i(F), {
                                    key: 1,
                                    style: { float: "right" }
                                  }, {
                                    default: u(() => a[7] || (a[7] = [
                                      w(" 门店默认 ", -1)
                                    ])),
                                    _: 1,
                                    __: [7]
                                  })) : L("", !0),
                                  b("div", null, C(r.regionName) + " " + C(r.address), 1)
                                ]),
                                _: 2
                              }, 1032, ["style", "onClick"]);
                            }), 128))
                          ])) : (R(), P("div", he, "暂无默认地址"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["default-value"]),
                  b("div", Ne, [
                    s(i(j), { onClick: Y }, {
                      default: u(() => a[8] || (a[8] = [
                        w("取消", -1)
                      ])),
                      _: 1,
                      __: [8]
                    }),
                    s(i(j), {
                      onClick: X,
                      style: { "margin-left": "30px" },
                      type: "primary"
                    }, {
                      default: u(() => a[9] || (a[9] = [
                        w("确定", -1)
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  Le as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/receiveAddress.ce.vue2.js
// module id = 1324
// module chunks = 67